import { CalculationInfoLegalGB } from '~/app/compositions/content/calculation-info/core/calculation-info-legal-gb';
import { ConfigurationOverviewLegalGB } from '~/app/compositions/content/configuration-overview-legal-gb';
import { PriceDetailsLegalGb } from '~/app/compositions/content/service-footer/components/price-details/price-details-legal-gb';
import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	combinations: ['trimLine', 'paint[bodyPaint]', 'rims', 'headlights', 'interior', 'packages'],
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'rotr',
			hiddenPriceParts: [
				'modelPriceWithFees',
				'financeableTotal',
				'taxTotal',
				'rotr',
				'taxTotalWeight',
				'totalRate',
				'total',
				'importCharge',
				'destinationCharge',
			],
			vatConfig: {
				feature: 'inclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {},
			},
		},
	},
	financeDomain: 'AUDI.UK.CRS',
	hideMonthlyRates: false,
	enableFinancingServices: true,
	enablePriceDisclaimer: true,
	pricePartsOrder: ['model', 'options', 'total', 'rotrRate'],
	pricePartsOrderFunction: (a, b) =>
		['model', 'options', 'total', 'rotrRate'].indexOf(a.type) -
		['model', 'options', 'total', 'rotrRate'].indexOf(b.type),
	hideConsumptionEmissionEngineName: true,
	nextBestActions: [
		{
			icon: '',
			description: 'Search available cars',
			labelText: 'Available Cars',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.co.uk/uk/web/en/new-car-search/results.html#filter=carline.{{carlineId}}',
		},
		{
			icon: 'hotline',
			description: 'Speak to your local Audi Centre',
			labelText: 'Contact Audi Centre',
			target: '_blank',

			trackingName: 'poa link',
			url: 'https://www.audi.co.uk/uk/web/en/call-me-back.html?',
		},
		{
			icon: 'test-drive',
			description: 'Book a test drive with your Audi',
			labelText: 'Book a test drive',
			target: '_blank',

			trackingName: 'testdrive',
			url: 'https://www.audi.co.uk/uk/web/en/find-and-buy/book-a-test-drive.html?',
		},
		{
			icon: 'wallbox',
			description: 'Discover financing options and special offers',
			labelText: 'Finance & offers',
			target: '_blank',

			trackingName: 'online leasing',
			url: 'https://www.audi.co.uk/uk/web/en/electric/offers-and-incentives.html',
		},
	],
	summaryFooterCta: {
		icon: 'test-drive',
		description: 'Book a test drive with your Audi',
		labelText: 'Book a test drive',
		target: '_blank',

		trackingName: 'testdrive',
		url: 'https://www.audi.co.uk/uk/web/en/find-and-buy/book-a-test-drive.html?',
	},
	showPricesWithFees: true,
	useBasePriceWithFees: true,
};

export const local_ui: PartialUiConfiguration = {
	calculationInfoComponent: <CalculationInfoLegalGB className="calculation" />,
	configOverviewComponent: <ConfigurationOverviewLegalGB />,
	priceDetailsComponent: <PriceDetailsLegalGb />,
};
